<template>
    <div  class="all-height">
        <el-main class="all-height">
            <div class="operation-bar">
                <h1>未处理订单明细</h1>
                <div class="operation-bar-right">
                    <div class="input-box">
                        <i class="el-icon-search" @click="query"></i>
                        <input type="text" v-model="keyword" placeholder="采购行项目号、物料编码或名称"/>
                    </div>
<!--                    <a href="javascript:void(0)" @click="submitToSap">签章</a>-->
                    <a href="javascript:void(0)" @click="exportExcel">导出Excel</a>
                    <a href="javascript:void(0)" @click="back">返回</a>
                </div>
            </div>

            <div class="table-box">
                <el-table :data="detailList" height="calc(100% - 55px)" @row-dblclick="editOrderDetails"
                          :header-cell-style="{background:'#4885CA', color: 'white'}">

                    <el-table-column type="index" width="50" label="序号" align="center" header-align="center" >
                    </el-table-column>
                    <el-table-column property="orderNo" width="120" label="订单编号" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column label="采购行项目" width="110"  align="center" header-align="center"  :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span type="text">{{scope.row.rowNo}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="sapSaleOrderNo" width="130" label="销售订单号" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column label="销售行项目" width="110"  align="center" header-align="center"  :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{scope.row.sapSaleOrderRowNo === '0'?'':scope.row.sapSaleOrderRowNo}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="物料编码" width="120" align="center" header-align="center"  :show-overflow-tooltip='true'>
                        <template slot-scope="scope">
                            <span>{{scope.row.sapMtrlCode.substr(-10,10)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="sapMtrlName" width="220" label="物料名称" align="center" header-align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="sapMtrlDesc" width="220" label="物料描述" align="center" header-align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="price" width="100"  label="价格" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="sapPriceUnit" width="100"  label="价格单位" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="sapTaxCodeDesc" width="100"  label="税率" align="center" header-align="center"
                                     :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="uom" width="70" label="单位" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="qty" width="90" label="数量" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="expectDate" width="100" label="交货日期" align="center" header-align="center"  :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="vendorRemark" width="150" label="沟通备注" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                    <el-table-column property="ownerRemark" width="150" label="采购方备注" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                    <el-table-column width="80" label="状态"  align="center" header-align="center">
                        <template slot-scope="scope">
                            <el-button type="text">
                                <el-tag type="warning" v-if="scope.row.statusX === '0'">暂存</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.statusX === '1'">待审核</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.statusX === '2'">已审核</el-tag>
                                <el-tag type="warning" v-else>未处理</el-tag>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"  align="center" header-align="center"  :show-overflow-tooltip='true'>
                        <template slot-scope="scope">
                            <el-button type="text">
                                <el-tag type="success" @click="downLoad(scope.row.sapMtrlCode.substr(-10,10))">下载</el-tag>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="table-page">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.current"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>

            <el-dialog
                    title="修改订单明细"
                    :show-close = "false"
                    :visible.sync="dialogVisible"
                    width="40%">
                <el-form :model="editForm">
                    <el-form-item label="物料编码" :label-width="labelWidth">
                        <el-input v-model="editForm.sapMtrlCode" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="物料名称" :label-width="labelWidth">
                        <el-input v-model="editForm.sapMtrlName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="价格" :label-width="labelWidth" >
                        <el-input v-model="editForm.price" type="number" :disabled = "forbidModify"></el-input>
                    </el-form-item>
                    <el-form-item label="交货日期" :label-width="labelWidth" >
                        <el-date-picker
                                v-model="editForm.expectDate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                style="width: 100%"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注" :label-width="labelWidth" >
                        <el-input v-model="editForm.vendorRemark" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button @click="modifyOrderDetail">暂时保存</el-button>
                <el-button type="primary" @click="submitOrderDetail">修改提交</el-button>
              </span>
            </el-dialog>
        </el-main>

    </div>

</template>

<script>
    export default {
        name: "nohandle-detail",
        props: ['orderId', 'isLock'],
        data() {
            return {
                forbidModify: false,
                detailList: [],
                page: {
                    current: 1,
                    pageSize: 15,
                    pageSizes: [15,30,50,100],
                    total: 0
                },
                keyword: '',
                labelWidth: '80px',
                current: 1,
                editForm: {
                    id: '',
                    sapMtrlCode: '',
                    sapMtrlName: '',
                    price: '',
                    expectDate: '',
                    vendorRemark: '',
                    ordersDetailModifyStatus: '',
                    ordersDetailModifyId: ''
                },
                editForm_bak: {},
                isModify: true,
                dialogVisible: false,
                keywords: ''
            }
        },
        methods: {
            //根据物料编码条用doc-server中的接口 下载相应的文件
            downLoad(no) {
                let param ={};
                param.no = no;
                // param.no = "2011003372";
                // param.no = "123";
                // param.no = "1010000554";
                this.$store.dispatch('order/order/download', param);
            },
            handleSizeChange(val) {
                this.page.pageSize = val;
                this.loadDetailList();
            },

            handleCurrentChange(val) {
                this.page.current = val;
                this.loadDetailList();
            },

            loadDetailList() {
                this.$store.dispatch('order/order/getOrderDetailList', {
                    current: this.page.current,
                    size: this.page.pageSize,
                    orderId: this.orderId,
                    keyword: this.keyword
                }).then((res)=> {
                    this.detailList = res.records;
                    this.page.total = res.total;
                })
            },

            query() {
                this.page.current = 1;
                this.loadDetailList();
            },

            back() {
              this.$emit("closeDetail");
            },

            exportExcel() {
                if(!this.orderId){
                    return;
                }
                this.$store.dispatch('order/order/exportExcel', {orderId: this.orderId});
            },

            submitToSap() {
                if(this.detailList.length === 0) {
                    this.$message.warning('当前订单没有对应的明细，无法同步！');
                    return;
                }
                if(this.detailList.filter(item=>item.statusX === '0' || item.statusX === '1').length >0) {
                    this.$message.warning('当前订单明细状态无法签章！');
                    return;
                }

                this.$confirm('请确认不需要再与采购方沟通?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('order/order/submitToSap', this.orderId).then((ret)=>{
                        if(ret.code === '200'){
                            this.$message.success(ret.data);
                            this.query();
                        }else{
                            this.$message.error(ret.data?ret.data : ret.message);
                        }
                    });
                }).catch(() => {
                    this.$message.info("已经取消");
                });
            },
            editOrderDetails(row) {
                if(row.statusX === '1'){
                    this.$message.warning('采购尚未审核，无法进行二次修改！！！');
                    return;
                }
                if(row.statusX === '2'){
                    this.$message.warning('已经审核通过, 请签章');
                    return;
                }
                if(row.allowModifyPrice === '2'){
                    this.forbidModify = true;
                }
                this.editForm = row;
                this.editForm_bak = JSON.parse(JSON.stringify(row));
                this.dialogVisible = true;
            },
            modifyOrderDetail() {
                if((this.editForm.vendorRemark==null?"":this.editForm.vendorRemark.trim()) === (this.editForm_bak.vendorRemark==null?"":this.editForm_bak.vendorRemark.trim())
                    && this.editForm.expectDate === this.editForm_bak.expectDate
                    && this.editForm.price === this.editForm_bak.price){
                    this.$message.warning('您没有进行信息变更');
                    return;
                }
                this.editForm.orderNo = this.editForm_bak.orderNo;
                this.editForm.rowNo = this.editForm_bak.rowNo;
                this.$store.dispatch('order/order/modifyOrderDetail', this.editForm).then((ret)=>{
                    if(ret.code === '200'){
                        this.$message.success(ret.message);
                        this.dialogVisible = false;
                        this.query();
                    }else{
                        this.$message.error(ret.data.data?ret.data.data : ret.message);
                    }
                })
            },

            submitOrderDetail() {
                if((this.editForm.vendorRemark==null?"":this.editForm.vendorRemark.trim()) === (this.editForm_bak.vendorRemark==null?"":this.editForm_bak.vendorRemark.trim())
                    && this.editForm.expectDate === this.editForm_bak.expectDate
                    && this.editForm.price === this.editForm_bak.price
                    && this.editForm.statusX === '未处理'){
                    this.$message.warning('您没有进行信息变更');
                    return;
                }
                this.editForm.orderNo = this.editForm_bak.orderNo;
                this.editForm.rowNo = this.editForm_bak.rowNo;
                this.$store.dispatch('order/order/submitOrderDetail',this.editForm).then((ret)=>{
                    if(ret.code === '200'){
                        this.$message.success(ret.message);
                        this.dialogVisible = false;
                        this.query();
                    }else{
                        this.$message.error(ret.data.data?ret.data.data : ret.message);
                    }
                })
            },

            cancel() {
                this.editForm.vendorRemark = this.editForm_bak.vendorRemark;
                this.editForm.price = this.editForm_bak.price;
                this.editForm.expectDate = this.editForm_bak.expectDate;
                this.dialogVisible = false;
            },

        },
        created() {
            this.loadDetailList();
        }
    };
</script>

<style scoped>
    .table-box{
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 35px);
        width: 100%;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
    .el-table .el-button{
        padding: 0;
    }
    .cell i {
        font-size: 25px;
        cursor: pointer;
    }
    .cell i:hover {
        color: #5ED1FD;
    }
    .textArea-box {
        max-height: 300px;
        overflow-y: scroll;
    }
</style>
